<template>
  <nav class="company-workspace-nav" aria-label="Company navigation">
    <button
      v-for="item in items"
      :key="item.id"
      class="company-workspace-nav__item"
      :class="{ 'company-workspace-nav__item--active': item.id === activeTab }"
      type="button"
      @click="$emit('change', item.id)"
    >
      <span class="company-workspace-nav__label">{{ item.label }}</span>
      <span v-if="item.count !== undefined" class="company-workspace-nav__count">
        {{ item.count }}
      </span>
    </button>
  </nav>
</template>

<script>
export default {
  name: 'CompanyWorkspaceNav',
  props: {
    items: {
      type: Array,
      required: true
    },
    activeTab: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.company-workspace-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.9rem;
}

.company-workspace-nav__item {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  min-height: 2.55rem;
  padding: 0 0.88rem;
  border: 1px solid rgba(114, 91, 62, 0.1);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.7);
  color: #4d3c2d;
  transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease;
}

.company-workspace-nav__item:hover {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(114, 91, 62, 0.14);
}

.company-workspace-nav__item--active {
  border-color: rgba(63, 49, 33, 0.08);
  background: linear-gradient(135deg, #2a221b 0%, #453629 100%);
  color: #f6efe5;
  box-shadow: 0 8px 18px rgba(43, 33, 24, 0.08);
}

.company-workspace-nav__label {
  font-size: 0.9rem;
  font-weight: 600;
}

.company-workspace-nav__count {
  min-width: 1.4rem;
  height: 1.4rem;
  padding: 0 0.3rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  font-size: 0.74rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.company-workspace-nav__item:not(.company-workspace-nav__item--active) .company-workspace-nav__count {
  background: rgba(88, 70, 48, 0.07);
  color: #5b4836;
}

@media (min-width: 1600px) {
  .company-workspace-nav {
    gap: 0.45rem;
  }

  .company-workspace-nav__item {
    min-height: 2.4rem;
    padding: 0 0.82rem;
  }
}

@media (max-width: 640px) {
  .company-workspace-nav {
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 0.2rem;
    scrollbar-width: thin;
  }

  .company-workspace-nav__item {
    flex-shrink: 0;
  }
}
</style>
